export default __webpack_public_path__ + "static/media/safety.58656d46.svg";